import { render, staticRenderFns } from "./InfoProduto.vue?vue&type=template&id=a5db3cb4"
import script from "./InfoProduto.vue?vue&type=script&lang=js"
export * from "./InfoProduto.vue?vue&type=script&lang=js"
import style0 from "./InfoProduto.vue?vue&type=style&index=0&id=a5db3cb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VBtn,VChip})
